package co.gul.ui.theme

import org.jetbrains.compose.web.css.px

object Radius {
    val sm = 8.px
    val md = 16.px
    val lg = 28.px
    val full = 999.px
}